import React from "react";

const PlaylistItem = () => {
 return (
    <div className="playkit-playlist__video-container">
        <div className="playkit-playlist__video-thumb"></div>
        <div className="playkit-playlist__video-info"></div>
    </div>
 )
}

const Skeleton = () => {
    return (
        <div className="playkit-video-stage playkit-video-stage--loading">
        <div className="playkit-video-stage__area-video">
        </div>
        <div className="playkit-video-stage__area-video-info">
            <div className="playkit-container">
            <div className="playkit-video-stage__area-video-info-container">
            <section className="playkit-video-info">
                <div className="playkit-video-info__ep-section"></div>
                <div className="playkit-video-info__details"></div>
                <div className="playkit-video-info__ep-description"></div>
                <div className="playkit-video-info-fake"></div>
            </section>
            </div>
            </div>
        </div>
        <div className="playkit-video-stage__area-playlist">
            <div className="playkit-playlist">
                <div className="playkit-playlist__top-area">
                    <h3 className="playkit-playlist__title">Veja Também</h3>
                </div>
                <div className="playkit-playlist__scroll">

                    <div className="playkit-playlist__playlist">
                    <PlaylistItem key={0}/>
                    <PlaylistItem key={1}/>
                    <PlaylistItem key={2}/>
                    <PlaylistItem key={3}/>
                    <PlaylistItem key={4}/>
                    <PlaylistItem key={5}/>
                    </div>
                </div>
            </div>
        </div>
        </div>
    )
}

export default Skeleton